import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import HeaderFilter from "../../../components/header/filter";
import DatePickerInputV1 from "../../../components/inputs/date-time/v1";
import TextInput from "../../../components/inputs/text";
import { BtnSearch } from "../../../components/button/button-search";
import libForm from "../../../util/libForm";
import { schemaFiltro } from "../filtros";
import { CONSOLIDADOS, MODELOS, STATUS } from "../status";

const CAMPOS = {
	modelo: { label: "Modelo", opcoes: Object.entries(MODELOS) },
	status: { label: "Status", opcoes: CONSOLIDADOS.map((valor) => [valor, STATUS[valor].rotulo]) },
	venda: { label: "Venda" },
	cpfCnpj: { label: "CPF/CNPJ" },
	cliente: { label: "Cliente", classe: "md:col-span-2" },
};

function Selecao({ id, label, opcoes, register }) {
	return (
		<div className="input-select-box d-flex flex-column">
			<label htmlFor={id}>{label}</label>
			<select id={id} {...register(id)} onKeyDown={libForm.EnterTab}>
				<option value="">TODOS</option>
				{opcoes.map(([valor, rotulo]) => (
					<option key={valor} value={valor}>
						{rotulo}
					</option>
				))}
			</select>
		</div>
	);
}

export default function FiltroFiscal({ titulo, campos, filtros, onFiltrar }) {
	const {
		register,
		control,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schemaFiltro),
		defaultValues: filtros,
	});

	return (
		<form onSubmit={handleSubmit(onFiltrar)}>
			<HeaderFilter title={titulo} />

			<div className="flex flex-col md:flex-row gap-4 mt-2">
				<div className="w-full md:w-1/2">
					<DatePickerInputV1 label="Data inicial" id="dtIni" control={control} errors={errors} />
				</div>
				<div className="w-full md:w-1/2">
					<DatePickerInputV1 label="Data final" id="dtFim" control={control} errors={errors} />
				</div>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 border-bottom pb-2">
				{campos.map((id) => {
					const { label, opcoes, classe } = CAMPOS[id];

					return opcoes ? (
						<Selecao key={id} id={id} label={label} opcoes={opcoes} register={register} />
					) : (
						<TextInput
							key={id}
							id={id}
							label={label}
							className={classe}
							register={register}
							errors={errors}
							onKeyDown={libForm.EnterTab}
						/>
					);
				})}
			</div>

			<footer>
				<div></div>
				<BtnSearch isSubmitting={isSubmitting} />
			</footer>
		</form>
	);
}
